module.exports = __webpack_public_path__ + "img/lg_ring_g_i_1_0@3x.b0f4ff28.png";